import React, { useRef } from 'react'
import { useInView } from 'react-intersection-observer'
import { DirectMessageItemSkeleton } from '@components/DirectMessages/DirectMessageItemSkeleton'
import { MotionBox } from '@ui'
import { isReduceMotion } from 'hooks/useDevice'

const REDUCE_MOTION = isReduceMotion()

export const SpaceSideBarListItem = React.memo(function SpaceSideBarListItem({
    children,
    checkVisibility = false,
}: {
    children: React.ReactNode
    checkVisibility?: boolean
}) {
    const { ref, inView } = useInView({
        rootMargin: '200px 0px',
        skip: !checkVisibility,
        initialInView: !checkVisibility,
    })

    const inViewRef = useRef(inView)
    inViewRef.current = inViewRef.current || inView

    return REDUCE_MOTION ? (
        children
    ) : (
        <MotionBox
            ref={ref}
            initial={{ opacity: 0 }}
            animate={{
                opacity: 1,
                transition: {
                    opacity: {
                        delay: 0.15,
                        duration: 0.25,
                        ease: 'easeIn',
                    },
                },
            }}
            exit={{ opacity: 0 }}
            layout="position"
            transition={{
                layout: { duration: 0.4, ease: 'circOut' },
            }}
        >
            {!checkVisibility || inViewRef.current ? children : <DirectMessageItemSkeleton />}
        </MotionBox>
    )
})
